import { CareerSettingService, SUCCESS_REPONSE_CODE, toastr, CustomToastrAction, TRANSLATION } from '@/imports-files/pages/career/career-setting';


export class CareerSettingAction
{

   constructor(setApiError)
   {
      this.CareerSettingService =   new CareerSettingService();
      this.setApiError          =   setApiError;
      this.customToastrAction   =   new CustomToastrAction(); 
   }

   async resetCarrerPage(setFlagForRerender, setConfirmation)
   {
      var result = await this.CareerSettingService.resetCareer();
      this.setApiError(result.request);

      if(result.request.status == SUCCESS_REPONSE_CODE)
      {
         this.customToastrAction.setNormalToastr('Carrer Page Reset Successfully.', 'success');
         // toastr.success('Carrer Page Reset Successfully.')
      }
      setConfirmation(false);
      setFlagForRerender(Math.random() * 10000);
   }

   copyToClipboard(link, setClipBoardMessage)
   {
      var textField        =  document.createElement('textarea');
      textField.innerText  =  link;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand('copy');
      textField.remove();
      setClipBoardMessage(TRANSLATION("career_site:settings:copied"));
      // document.querySelector('.ClipboardTooltip').lastChild.textContent = 'Copied';
   }

   getIframeValue(link)
   {
      return `<iframe src='${link}?type=iframe'  style="width:100%" height="500px" title="Heartpace job listing"></iframe>`
   }
}
